import { useState, useEffect, useRef } from "react";
import { CARD_COLORS, BRAND } from "../constants";
import { getCardLayout } from "../utils/cardLayout.js";

export default function TributeCard({ tribute, index, onCardClick, isNew }) {
  var colors = CARD_COLORS[tribute.variant % CARD_COLORS.length];
  var ref = useRef(null);
  var [visible, setVisible] = useState(false);

  var { rotation, offsetX, offsetY, widthPct, justifySelf, seed } = getCardLayout(tribute.id, index);

  useEffect(function() {
    var obs = new IntersectionObserver(
      function(entries) { if (entries[0].isIntersecting) setVisible(true); },
      { threshold: 0.01, rootMargin: "2000px" }
    );
    if (ref.current) obs.observe(ref.current);
    return function() { obs.disconnect(); };
  }, []);

  var msgLen = tribute.message.length;
  var defaultShadow = "0 2px 8px rgba(0,0,0,0.06), 1px 2px 4px rgba(0,0,0,0.04)";
  var hoverShadow = "0 4px 16px rgba(0,0,0,0.12), 1px 3px 8px rgba(0,0,0,0.06)";

  return (
    <div
      ref={ref}
      onClick={function() { onCardClick(tribute.id, index); }}
      style={{
        position: "relative",
        overflow: "hidden",
        background: colors.bg,
        border: isNew ? "1.5px solid " + BRAND.gold : "1px solid " + colors.border,
        borderRadius: "6px",
        padding: "22px 26px",
        opacity: visible ? 1 : 0,
        transform: visible
          ? "rotate(" + rotation + "deg) translate(" + offsetX + "px, " + offsetY + "px)"
          : "rotate(0deg) translateY(30px)",
        transition: "opacity 0.4s ease " + (index * 0.04) + "s, transform 0.5s ease " + (index * 0.04) + "s, box-shadow 0.2s ease",
        display: "flex",
        flexDirection: "column",
        gap: "12px",
        boxShadow: defaultShadow,
        width: widthPct + "%",
        justifySelf: justifySelf,
        cursor: "pointer",
      }}
      onMouseOver={function(e) { e.currentTarget.style.boxShadow = hoverShadow; }}
      onMouseOut={function(e) { e.currentTarget.style.boxShadow = defaultShadow; }}
    >
      {isNew && (
        <>
          <div style={{
            position: "absolute",
            top: "8px",
            right: "8px",
            background: BRAND.gold,
            color: "#fff",
            fontSize: "10px",
            fontWeight: 700,
            padding: "2px 8px",
            borderRadius: "10px",
            textTransform: "uppercase",
            letterSpacing: "0.5px",
            zIndex: 1,
          }}>
            New
          </div>
          <div style={{
            position: "absolute",
            top: 0,
            left: "-100%",
            width: "100%",
            height: "100%",
            background: "linear-gradient(90deg, transparent, " + colors.shimmer + ", transparent)",
            animation: "shimmer 2.5s ease-in-out infinite",
          }} />
        </>
      )}
      <div style={{ lineHeight: 1.5 }}>
        <div style={{ fontSize: "13.5px", color: "#555" }}>
          To: <span style={{ color: "#333", fontWeight: 600 }}>{tribute.teacher}</span>
        </div>
        <div style={{ fontSize: "13.5px", color: "#555" }}>
          From: <span style={{ color: "#333" }}>{tribute.from}</span>
        </div>
      </div>
      <div style={{
        fontFamily: "'Caveat', cursive",
        fontSize: msgLen < 30 ? "32px" : msgLen < 60 ? "26px" : "22px",
        fontWeight: 500,
        color: "#1A1A1A",
        lineHeight: 1.3,
      }}>
        {tribute.message}
      </div>
      <div style={{ fontSize: "11px", color: "#BBB" }}>{tribute.school}</div>
    </div>
  );
}
